import { Box, type ComponentWithAs, Flex, Grid, type IconProps, Text } from "@chakra-ui/react"

import { CountTag } from "@/components/CountTag"
import { isNotNullNorUndefined } from "@/utils/ts-utils"

type Props = React.PropsWithChildren<{
  title: React.ReactNode
  icon?: ComponentWithAs<"svg", IconProps>
  count?: number
  isConfidential?: boolean
  // First section right under the tabs: the tab bar already draws the line.
  isFirst?: boolean
}>

// A section of a record sheet, "editorial ledger" layout of the BARNES Design System (ADR 0005,
// D1 revised on 2026-10-02): always open, the section name in a fixed-width margin, the content
// next to it, a line between sections. The fixed margin keeps every section aligned.
export const SheetSection: React.FC<Props> = ({
  title,
  icon: Icon,
  count,
  isConfidential,
  isFirst,
  children,
}) => (
  <Grid
    as="section"
    templateColumns={{ base: "1fr", lg: "240px minmax(0, 1fr)" }}
    columnGap="10"
    rowGap="5"
    borderTop={isFirst ? "none" : "1px solid"}
    borderColor="line"
    py="8"
  >
    <Flex
      alignItems="center"
      alignSelf="start"
      gap="3"
      color={isConfidential ? "textSubtle" : "text"}
    >
      {Icon && <Icon boxSize="4" color={isConfidential ? "textSubtle" : "textMuted"} />}
      <Text
        as="h4"
        fontSize="xs"
        fontWeight="semibold"
        letterSpacing="widest"
        textTransform="uppercase"
      >
        {title}
      </Text>
      {isNotNullNorUndefined(count) && <CountTag count={count} variant="counter" hideParentheses />}
    </Flex>
    <Box minW={0}>{children}</Box>
  </Grid>
)
